import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { initUiTracking } from './telemetry/ui-tracking';

initUiTracking();

const container = document.getElementById('root')!;
const app = (
  <React.StrictMode>
    <App path={window.location.pathname} />
  </React.StrictMode>
);

// The edge server serves prerendered markup for the canonical routes, but the
// vite dev server (and the untouched index.html template, used as a fallback
// when a build has not produced the prerendered page) serves an empty #root.
// createRoot on prerendered markup throws it away and re-renders, which
// flashes; hydrateRoot on an empty container floods the console with mismatch
// errors. Branch on what is actually in the container.
if (container.firstChild) {
  ReactDOM.hydrateRoot(container, app);
} else {
  ReactDOM.createRoot(container).render(app);
}
